import type { TFunction } from "i18next";
import { toast } from "react-toastify";

export { invalidateCachesForDeliveryIds } from "@/features/delivery/cache";

type BulkResult = {
  successCount: number;
  failures: Array<{ deliveryId: number; message: string }>;
};

function getErrorMessage(error: unknown, t: TFunction) {
  if (error instanceof Error) {
    return error.message.split(": ")[1] ?? error.message;
  }
  return t("network.errors.unknown");
}

export function toastBulkDeliveryResult(
  t: TFunction,
  result: BulkResult,
  fullSuccessKey: string,
  partialKey: string
) {
  const opts = { position: "bottom-right" as const };
  if (result.failures.length === 0) {
    toast.success(t(fullSuccessKey, { count: result.successCount }), opts);
    return;
  }
  if (result.successCount === 0) {
    const detail = result.failures.map((f) => `${f.deliveryId}: ${f.message}`).join("; ");
    toast.error(
      t(partialKey, { success: result.successCount, failed: result.failures.length, detail }),
      opts
    );
    return;
  }
  const detail = result.failures.map((f) => `${f.deliveryId}: ${f.message}`).join("; ");
  toast.warning(
    t(partialKey, { success: result.successCount, failed: result.failures.length, detail }),
    opts
  );
}

export function toastBulkMutationError(error: unknown, t: TFunction) {
  toast.error(getErrorMessage(error, t), { position: "bottom-right" });
}
